import dayjs, { browserTimezone } from './dayjsSetup';

const formatDate = (inputDate: string) => {
  const date = dayjs.utc(inputDate).tz(browserTimezone);
  return date.format('YYYY-MM-DD HH:mm');
};

export default formatDate;
